import { combineReducers } from 'redux';

import libraryItemReducer from './item';
import categoryReducer from './category';
import salesTypeReducer from './salesType';
import libraryModifierReducer from './modifier';
import libraryPromoReducer from './promo';

export default combineReducers({
  itemHub: libraryItemReducer,
  categoryHub: categoryReducer,
  salesTypeHub: salesTypeReducer,
  modifierHub: libraryModifierReducer,
  promo: libraryPromoReducer,
});
